import React from "react";
import {
  Content,
  ContentVariants,
} from "@patternfly/react-core";
import { Link } from "react-router-dom";

import "./SchoolFooterColumn.css";

const FooterLink = ({ link }) => {
  if (link.external) {
    return (
      <a
        href={link.to}
        target="_blank"
        rel="noopener noreferrer"
        className="school-footer-link"
      >
        {link.label}
      </a>
    );
  }

  return (
    <Link
      to={link.to}
      className="school-footer-link"
    >
      {link.label}
    </Link>
  );
};

const SchoolFooterColumn = ({ item }) => {
  const sections = item.megaMenu?.sections
    ?.filter((section) => section.showInFooter !== false)
    .map((section) => ({
      ...section,
      links: [...(section.links ?? [])]
        .filter((link) => link.showInFooter !== false)
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    }))
    .filter((section) => section.links.length > 0);

  return (
    <div className="school-footer-column">
      <Content
        component={ContentVariants.h4}
        className="school-footer-column-title"
      >
        {item.label}
      </Content>

      {sections?.length > 0 ? (
        <ul className="school-footer-column-list">
          {sections.flatMap((section) =>
            section.links.map((link) => (
              <li
                key={`${section.id}-${link.id}`}
                className="school-footer-column-list-item"
              >
                <FooterLink link={link} />
              </li>
            ))
          )}
        </ul>
      ) : (
        item.to && (
          <ul className="school-footer-column-list">
            <li className="school-footer-column-list-item">
              <FooterLink
                link={{
                  label: item.label,
                  to: item.to,
                  external: item.external ?? false,
                }}
              />
            </li>
          </ul>
        )
      )}
    </div>
  );
};

export default SchoolFooterColumn;